<template>
    <div>
        <rkm-modal
            :buttons="['cancel']"
            extraLarge
            ref="RkmModal"
            title="Exames do agendamento"
        >

        <rkm-alert show info v-if="item">
            <strong>Paciente:</strong>

            {{ item.pacienteNome }}

            <strong v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                ({{ item.pacienteNomeSocial }})
            </strong> -

            <strong>Prontuário: </strong>{{ item.pacienteProntuario }} -
            <strong>Agendamento: </strong>{{ item.agendamentoNumero }}
        </rkm-alert>

            <template>

                <rkm-table
                    :items="exames"
                    :fields="fields"
                >
                </rkm-table>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "exameNome",
                    label: "Exame",
                    class: 'col-6',
                    sortable: true
                },
                {
                    key: "status",
                    label: "Status",
                    class: 'col-6',
                    sortable: true
                },
            ]

            return fields
        },
    },
    created() {

        this.repositories = {
            laudo: this.getConectaSusRepository('exameLaboratorial.importarLaudo'),
        }
    },
    data: () => ({
        exames: [],
        item: [],
        id: null,
        enums: { preferenciaNome },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.laudo.getExames(this.id)
                .then(({ data }) => {

                    this.exames = data.form.exames
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        open(item) {

            this.item = item

            this.id = item.agendamentoId
            this.load()

            this.$refs.RkmModal.show()
        },
    },
    mixins: [repository, object, data, formats],
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
</style>
